const actionTypes = {
  SET_FOLDER_INFO_DETAIL: 'setFolderInfoDetail',
  SET_FOLDER_INFO_DETAIL_SAME: 'setFolderInfoDetailSame',
  PUT_FOLDER_INFO_DETAIL: 'putFolderInfoDetail',
  SET_FOLDER_INFO_USERS_DETAIL: 'setFolderInfoUsersDetail',
  SET_FOLDER_INFO_USERS_DETAIL_N: 'setFolderInfoUsersDetailN',
  SET_FOLDER_INFO_USERS_DETAIL_ALL: 'setFolderInfoUsersDetailAll',
  SET_FOLDER_INFO_USERS_DETAIL_ALL_SAME: 'setFolderInfoUsersDetailAllSame',
  PUT_FOLDER_INFO_USERS_DETAIL: 'putFolderInfoUsersDetail',
  DELETE_FOLDER_INFO_USERS_DETAIL: 'deleteFolderInfoUsersDetail',
  SET_FOLDER_INFO_EDIT_USERS_LIST: 'setFolderInfoEditUsersList',
  SET_FOLDER_INFO_USERS_SELECT_LIST: 'setFolderInfoUsersSelectList',
  SET_FOLDER_INFO_DETAIL_CHECKED_LIST: 'setFolderInfoDetailCheckedList',
  SET_MODAL_USER_INFO_ADD_ACTIVED: 'setModalUserInfoAddActived',
  INIT_USER_INFO_LISTS: 'initUserInfoLists',
  SET_ORIGIN_USER_INFO_LISTS: 'setOriginUserInfoLists',
  SET_BACKUP_USER_INFO_LISTS: 'setBackupUserInfoLists',
  SET_DISPLAY_USER_INFO_LISTS: 'setDisplayUserInfoLists',
  SET_TABLE_USER_INFO_LISTS: 'setTableUserInfoLists',
  SET_SEARCH_USER_INFO_LISTS: 'setSearchUserInfoLists',
}

export default actionTypes
